document.addEventListener('DOMContentLoaded', function () {
    function updateQtyInput(qtyInput, clicked) {
        // Change the value after a short delay
        var val = parseFloat(qtyInput.value);
        var max = qtyInput.getAttribute('max') ? parseFloat(qtyInput.getAttribute('max')) : 1000000;
        var min = qtyInput.getAttribute('min') ? parseFloat(qtyInput.getAttribute('min')) : 1;
        var step = qtyInput.getAttribute('step') ? parseFloat(qtyInput.getAttribute('step')) : 1;
        var newValue = val;

        // Change the value if plus or minus
        if (clicked.classList.contains('plus')) {
            if (max && (max <= val)) {
                newValue = max;
            } else {
                newValue = val + step;
            }
        } else {
            if (min && (min >= val)) {
                newValue = min;
            } else if (val > 1) {
                newValue = val - step;
            }
        }

        qtyInput.value = newValue;

        if (clicked.closest('.qty-lef-wrapper')) {
            var quantityData = clicked.closest('.qty-lef-wrapper').nextElementSibling;
            quantityData.setAttribute('data-quantity', newValue);
        }

        const updateCartButton = document.querySelector('button[name="update_cart"]');
        if (updateCartButton) {
            updateCartButton.disabled = false; // Remove the disabled attribute
        }

        setTimeout(() => {
            qtyInput.dispatchEvent(new Event('change'));
        }, 300);
    }

    if (document.body.classList.contains('lef-webshop')) {
        // Quantity button event listener for '.quantity'
        document.body.addEventListener('click', function (e) {
            if (e.target.matches('button.plus, button.minus')) {
                // Get current quantity values
                var qty = e.target.closest('.quantity').querySelector('.qty');
                updateQtyInput(qty, e.target);
            }
        });

        if (document.querySelector('.filter-item')) {
            toggleFilter();
            primaryFilterClick();
        }
    }

    if (document.querySelector('.checkout-coupon-overlay')) {
        document.body.addEventListener('click', function (e) {
            var applyBtn = e.target.closest('.checkout-coupon-overlay button[name="apply_coupon"]');
            if (applyBtn) {
                e.preventDefault();

                // Get the coupon code from the input field
                var couponCodeInput = applyBtn.parentElement.querySelector('input[name="coupon_code"]');
                var coupon_code = couponCodeInput.value;

                // Call WooCommerce's apply_coupon endpoint directly
                jQuery.ajax({
                    type: 'POST',
                    url: wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon'),
                    data: {
                        coupon_code: coupon_code,
                        security: wc_checkout_params.apply_coupon_nonce
                    },
                    success: function (responseHTML) {
                        // Trigger checkout refresh (re-renders #order_review fragment)
                        jQuery(document.body).trigger('update_checkout', { update_shipping_method: false });

                        // After the fragment re-render, inject the response notice near the coupon input
                        jQuery(document.body).one('updated_checkout', function () {
                            var couponOverlayHolder = document.querySelector('.checkout-coupon-overlay-holder');
                            if (!couponOverlayHolder) return;
                            var noticeWrapper = document.createElement('div');
                            noticeWrapper.classList.add('checkout-coupon-notice');
                            noticeWrapper.innerHTML = responseHTML;
                            couponOverlayHolder.appendChild(noticeWrapper);
                        });
                    }
                });
            }
        });
    }

    // Billing/shipping address collapsible for logged-in users with saved address
    var checkoutDetailsEl = document.querySelector('.checkout-details.has-saved-address');
    if (checkoutDetailsEl) {
        var addressToggleBtn  = checkoutDetailsEl.querySelector('.checkout-address-toggle');
        var customerDetailsEl = checkoutDetailsEl.querySelector('#customer_details');

        function escHtml(str) {
            return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        function getBillingInfo() {
            var bFirst    = (document.querySelector('#billing_first_name') || {}).value || '';
            var bLast     = (document.querySelector('#billing_last_name') || {}).value || '';
            var bName     = (bFirst + ' ' + bLast).trim();

            // Support WooCommerce Postcode Checker (street_name + house_number fields)
            var bStreet   = (document.querySelector('#billing_street_name') || {}).value || '';
            var bHouseNum = (document.querySelector('#billing_house_number') || {}).value || '';
            var bHouseSuf = (document.querySelector('#billing_house_number_suffix') || {}).value || '';
            var bAddr1    = (document.querySelector('#billing_address_1') || {}).value || '';
            var bStreetAddress = bStreet
                ? (bStreet + ' ' + (bHouseNum + bHouseSuf).trim()).trim()
                : bAddr1;

            var bPostcode = (document.querySelector('#billing_postcode') || {}).value || '';
            var bCity     = (document.querySelector('#billing_city') || {}).value || '';
            var bCountryEl = document.querySelector('#billing_country');
            var bCountry  = bCountryEl && bCountryEl.selectedIndex >= 0
                ? bCountryEl.options[bCountryEl.selectedIndex].text : '';
            var bParts = [bStreetAddress, (bPostcode + ' ' + bCity).trim(), bCountry].filter(function (p) { return p; });
            return { name: bName, address: bParts.join(', ') };
        }

        function updateAddressSummary() {
            var addressSummaryInfo = document.querySelector('.checkout-address-summary-info');
            if (!addressSummaryInfo) return;

            var shippingCheckbox = document.querySelector('#ship-to-different-address-checkbox');
            var shippingActive = shippingCheckbox && shippingCheckbox.checked;
            var billing = getBillingInfo();

            if (!shippingActive) {
                addressSummaryInfo.innerHTML =
                    '<span class="address-label">Verzenden naar:</span>' +
                    '<strong>' + escHtml(billing.name) + '</strong>' +
                    '<span>' + escHtml(billing.address) + '</span>';
                return;
            }

            var sFirst    = (document.querySelector('#shipping_first_name') || {}).value || '';
            var sLast     = (document.querySelector('#shipping_last_name') || {}).value || '';
            var sName     = (sFirst + ' ' + sLast).trim();

            // Support WooCommerce Postcode Checker (street_name + house_number fields)
            var sStreet   = (document.querySelector('#shipping_street_name') || {}).value || '';
            var sHouseNum = (document.querySelector('#shipping_house_number') || {}).value || '';
            var sHouseSuf = (document.querySelector('#shipping_house_number_suffix') || {}).value || '';
            var sAddr1    = (document.querySelector('#shipping_address_1') || {}).value || '';
            var sAddr     = sStreet
                ? (sStreet + ' ' + (sHouseNum + sHouseSuf).trim()).trim()
                : sAddr1;

            var sPostcode = (document.querySelector('#shipping_postcode') || {}).value || '';
            var sCity     = (document.querySelector('#shipping_city') || {}).value || '';
            var sCountryEl = document.querySelector('#shipping_country');
            var sCountry  = sCountryEl && sCountryEl.selectedIndex >= 0
                ? sCountryEl.options[sCountryEl.selectedIndex].text : '';

            var shippingParts = [sAddr, (sPostcode + ' ' + sCity).trim(), sCountry].filter(function (p) { return p; });
            var shippingAddress = shippingParts.join(', ');

            // Shipping block first
            var html = '<span class="address-label">Verzenden naar:</span>';
            html += '<strong>' + escHtml(sName) + '</strong>';
            html += '<span>' + escHtml(shippingAddress) + '</span>';

            // Billing block below
            html += '<span class="summary-separator"></span>';
            html += '<span class="address-label">Factureren aan:</span>';
            html += '<strong>' + escHtml(billing.name) + '</strong>';
            html += '<span>' + escHtml(billing.address) + '</span>';

            addressSummaryInfo.innerHTML = html;
        }

        if (addressToggleBtn && customerDetailsEl) {
            if (checkoutDetailsEl.classList.contains('is-editing')) {
                addressToggleBtn.textContent = 'Verberg adres';
            } else {
                customerDetailsEl.classList.add('address-form-collapsed');
            }

            addressToggleBtn.addEventListener('click', function () {
                var isCollapsed = customerDetailsEl.classList.contains('address-form-collapsed');
                customerDetailsEl.classList.toggle('address-form-collapsed', !isCollapsed);
                checkoutDetailsEl.classList.toggle('is-editing', isCollapsed);
                addressToggleBtn.textContent = isCollapsed ? 'Verberg adres' : 'Wijzig adres';
            });

            // Auto-expand when WooCommerce reports a checkout validation error
            jQuery(document.body).on('checkout_error', function () {
                customerDetailsEl.classList.remove('address-form-collapsed');
                checkoutDetailsEl.classList.add('is-editing');
                addressToggleBtn.textContent = 'Verberg adres';
            });
        }

        // Initialize summary with label on page load
        updateAddressSummary();

        // Watch shipping checkbox and fields — update summary in real-time
        document.body.addEventListener('change', function (e) {
            if (e.target.id === 'ship-to-different-address-checkbox') {
                updateAddressSummary();
            }
        });

        var shippingFieldIds = ['shipping_first_name', 'shipping_last_name', 'shipping_address_1', 'shipping_street_name', 'shipping_house_number', 'shipping_house_number_suffix', 'shipping_postcode', 'shipping_city', 'shipping_country'];
        shippingFieldIds.forEach(function (id) {
            document.body.addEventListener('input', function (e) {
                if (e.target.id === id) updateAddressSummary();
            });
            document.body.addEventListener('change', function (e) {
                if (e.target.id === id) updateAddressSummary();
            });
        });

        var billingFieldIds = ['billing_first_name', 'billing_last_name', 'billing_address_1', 'billing_street_name', 'billing_house_number', 'billing_house_number_suffix', 'billing_postcode', 'billing_city', 'billing_country'];
        billingFieldIds.forEach(function (id) {
            document.body.addEventListener('input', function (e) {
                if (e.target.id === id) updateAddressSummary();
            });
            document.body.addEventListener('change', function (e) {
                if (e.target.id === id) updateAddressSummary();
            });
        });

        // WooCommerce Postcode Checker fires this jQuery event after filling street + city via AJAX
        if (typeof jQuery !== 'undefined') {
            jQuery(document.body).on('wpo_wcnlpc_fields_updated', updateAddressSummary);
        }
    }

    // Checkout login form toggle
    var loginToggleLink = document.querySelector('.woocommerce-form-login-toggle a.showlogin');
    var loginFormEl     = document.querySelector('form.woocommerce-form-login');

    if (loginToggleLink && loginFormEl) {
        loginToggleLink.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var isHidden = window.getComputedStyle(loginFormEl).display === 'none';
            loginFormEl.style.display = isHidden ? 'block' : 'none';
        });
    }

    // Mobile checkout order summary toggle
    var mobileToggleBtn = document.querySelector('.checkout-mobile-toggle-btn');
    var checkoutTotalsHolder = document.querySelector('.checkout-totals-holder');

    if (mobileToggleBtn && checkoutTotalsHolder) {
        // Start collapsed on mobile
        if (window.innerWidth <= 991) {
            checkoutTotalsHolder.classList.add('totals-mobile-collapsed');
        }

        mobileToggleBtn.addEventListener('click', function () {
            var isCollapsed = checkoutTotalsHolder.classList.contains('totals-mobile-collapsed');
            checkoutTotalsHolder.classList.toggle('totals-mobile-collapsed', !isCollapsed);
            mobileToggleBtn.classList.toggle('is-open', isCollapsed);
            mobileToggleBtn.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
        });

        // Keep toggle total in sync with order total after checkout updates
        if (typeof jQuery !== 'undefined') {
            jQuery(document.body).on('updated_checkout', function () {
                var totalAmountEl = document.querySelector('.checkout-totals .order-totals .cart-total-amount');
                var toggleTotal = document.querySelector('.checkout-mobile-toggle-btn .toggle-total');
                if (totalAmountEl && toggleTotal) {
                    toggleTotal.innerHTML = totalAmountEl.innerHTML;
                }
            });
        }
    }

    // Mobile before-submit product list toggle
    var submitToggleBtn = document.querySelector('.checkout-mobile-submit-toggle');
    var submitProducts  = document.querySelector('.checkout-mobile-submit-products');

    if (submitToggleBtn && submitProducts) {
        submitToggleBtn.addEventListener('click', function () {
            var isOpen = submitProducts.classList.contains('is-open');
            submitProducts.classList.toggle('is-open', !isOpen);
            submitToggleBtn.classList.toggle('is-open', !isOpen);
            submitToggleBtn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        });
    }

    // Totals loading overlay — shown while WooCommerce fetches updated fragments
    var checkoutTotalsEl = document.querySelector('.checkout-totals');
    if (checkoutTotalsEl && typeof jQuery !== 'undefined') {
        jQuery(document.body).on('update_checkout', function () {
            checkoutTotalsEl.classList.add('is-loading');
        });
        jQuery(document.body).on('updated_checkout', function () {
            checkoutTotalsEl.classList.remove('is-loading');
        });
    }

    setTimeout(function() {
        if (document.querySelectorAll('.show-password-input')) {
            var password_inputs = document.querySelectorAll('.show-password-input');

            password_inputs.forEach(function (element) {
                element.innerHTML = '<i class="icon icon-eye" style="margin-right: unset;"></i>';
            });
        }
    }, 50);

    // Order notes toggle
    var orderNotesCheckbox = document.getElementById('lef-order-notes-toggle');
    var orderNotesPanel = document.querySelector('.order-notes-collapsible');

    if (orderNotesCheckbox && orderNotesPanel) {
        orderNotesCheckbox.addEventListener('change', function () {
            orderNotesPanel.classList.toggle('is-open', this.checked);
        });
    }

});

function toggleFilter() {
    var elements = document.querySelectorAll('.filter-holder .filter-item .open-switcher, .filter-holder .filter-item .filter-title');
    var action = "click";

    elements.forEach(function (element) {
        element.addEventListener(action, function () {
            var parent = element.parentElement;

            if (parent.classList.contains('filter-closed')) {
                parent.classList.remove('filter-closed');
                var filterItems = parent.querySelector('.filter-elements');
                if (filterItems) {
                    filterItems.style.display = 'block';
                    setTimeout(function () {
                        filterItems.style.transition = 'height 300ms';
                    }, 0);
                }
            } else {
                parent.classList.add('filter-closed');
                var filterItems = parent.querySelector('.filter-elements');
                if (filterItems) {
                    filterItems.style.display = 'none';
                }
            }
        });
    });
}

function primaryFilterClick() {
    var elements = document.querySelectorAll('.primary-filters .primary-filter');
    var action = "click";

    elements.forEach(function (element) {
        element.addEventListener(action, function () {
            var category = element.getAttribute('data-filter-category');
            var filterItem = document.querySelector('.all-filters-holder .filter-item input#' + category);

            if (filterItem) {
                filterItem.click();
            }
        });
    });
}
